import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export type ToastKind = "success" | "error" | "info";

export interface ToastMessage {
  id: number;
  kind: ToastKind;
  text: string;
}

@Injectable({ providedIn: "root" })
export class ToastService {
  private readonly state = new BehaviorSubject<ToastMessage[]>([]);
  readonly toasts$ = this.state.asObservable();

  show(kind: ToastKind, text: string, timeoutMs = 2800): void {
    const toast: ToastMessage = { id: Date.now() + Math.floor(Math.random() * 1000), kind, text };
    const next = [...this.state.value, toast];
    this.state.next(next);

    setTimeout(() => this.dismiss(toast.id), timeoutMs);
  }

  dismiss(id: number): void {
    this.state.next(this.state.value.filter((t) => t.id !== id));
  }
}
